<template>
<div>
    <nav-bar-home></nav-bar-home>
    <main id="main category">
        <section class="category-w parten-bg card-position">
            <div class="container">
                <div class="row">
                    <aside id="sidebar_cate" class="col-sm-3 hidden-xs" v-if="vw > 480">
                        <h3 class="sidebar-title">Category</h3>
                        <ul id="cate_list" class="cate_list">
                            <li class="level0 parent" v-for="cat in categories" :key="cat._id">
                                <a class="categoryFlexWrap" href="javascript:void(0)" :title="cat.name" @click.prevent="toggleDisplay(cat._id)">
                                    <span>{{ cat.name }}</span>
                                    <div class="iconWrapRow">
                                        <i class="fa" :class="openCategories[cat._id] ? 'fa-minus' : 'fa-plus'"></i>
                                    </div>
                                </a>
                                <ul class="level0" v-if="groupedSubCategories[cat._id] && groupedSubCategories[cat._id].length > 0" :style="{ display: openCategories[cat._id] ? 'block' : 'none' }">
                                    <li class="level1 nav-1-1 first item" @click="loadProducts(subcat.slug, subcat.name)" v-for="subcat in groupedSubCategories[cat._id]" :key="subcat._id">
                                        <a href="javascript:void(0)" :title="subcat.name">
                                            {{ subcat.name }}
                                            <!-- <span class="count-item">(22)</span> -->
                                        </a>
                                    </li>

                                </ul>
                            </li>
                        </ul>
                        <div style="margin-top: 25%;">
                            <div class="card-img">
                                <img src="/images/testimonials/quotes_slider.png" alt="">
                            </div>
                            <div class="card-text">
                                <p>
                                    Product or Service not listed here, no problem <a href="/quotes-form">QUOTES</a> team here,
                                    explain
                                    your requirement and our team will respond within 24-48 hrs with a competitive price
                                </p>
                            </div>
                        </div>
                    </aside>
                    <!--Category product grid : Begin -->
                    <section class="category grid col-sm-9 col-xs-12">
                        <div v-if="loading" class="row">
                            <div class="col-xs-12 category-image visible-md visible-lg">
                                <div style="height: 244px; width: 100%; background-color: #f3f3f3; border-radius: 8px;"></div>
                            </div>
                        </div>
                        <div v-else-if="getCatBannerByCategory && getCatBannerByCategory.data" class="row">
							<div class="col-xs-12 category-image visible-md visible-lg">
								<a href="javascript:void(0)" title="category image" style="text-decoration: none;">
								<div class="postCardWrap"
									:class="getCatBannerByCategory.data.position"
									:style="{ backgroundColor: getCatBannerByCategory.data.bgColor, fontFamily: getCatBannerByCategory.data.fontFamily }">
									<div class="postCont">
									<div class="cardTitle"
										:style="{ color: getCatBannerByCategory.data.headingColor, fontSize: getCatBannerByCategory.data.headingSize, fontWeight: getCatBannerByCategory.data.headingBold ? 'bold' : 'normal' }">
										{{ getCatBannerByCategory.data.heading }}
									</div>
									<p :style="{ color: getCatBannerByCategory.data.subheadingColor, fontSize: getCatBannerByCategory.data.subheadingSize, fontWeight: getCatBannerByCategory.data.subheadingBold ? 'bold' : 'normal' }">
										{{ getCatBannerByCategory.data.subheading }}
									</p>
									</div>
									<div class="postImg">
									<img :src="getCatBannerByCategory.data.previewImage" alt="Slider Image" />
									</div>
								</div>
								</a>
							</div>
						</div>
                        <div v-else class="row">
                            <div class="col-xs-12 category-image visible-md visible-lg">
                                <a href="javascript:void(0)" title="category image" style="text-decoration: none;">
                                    <div v-if="productBannerData?.position" class="postCardWrap" :class="productBannerData.position" :style="{ backgroundColor: productBannerData.bgColor, fontFamily: productBannerData.fontFamily }">
                                        <div class="postCont">
                                            <div class="cardTitle" :style="{ color: productBannerData.headingColor, fontSize: productBannerData.headingSize, fontWeight: productBannerData.headingBold ? 'bold' : 'normal' }">
                                                {{ productBannerData.heading }}</div>
                                            <p :style="{ color: productBannerData.subheadingColor, fontSize: productBannerData.subheadingSize, fontWeight: productBannerData.subheadingBold ? 'bold' : 'normal' }">
                                                {{ productBannerData.subheading }}</p>
                                        </div>
                                        <div class="postImg">
                                            <img :src="productBannerData.previewImage" alt="Slider Image" />
                                        </div>
                                    </div>
                                    
                                </a>
                            </div>
                        </div>
                        <div class="top-toolbar row">
                            <div class="col-md-3 col-sm-4 col-xs-4 type-filter" style="display:none;">
                                <span class="cate-filter-title hidden-xs">Product Type:</span>
                                <div class="cate-filter-content">
                                    <span class="current-filter hidden-xs">Business<i class="fa fa-angle-down"></i></span>
                                    <span class="current-filter visible-xs">Type: <i class="fa fa-angle-down"></i></span>
                                    <ul class="product-type-filter">
                                        <li>
                                            <span>Flyers & Leaflets</span>
                                        </li>
                                        <li class="selected">
                                            <span>Business Card</span>
                                        </li>
                                        <li>
                                            <span>Poster Prints</span>
                                        </li>
                                        <li>
                                            <span>Card & Invites</span>
                                        </li>
                                        <li>
                                            <span>Banner & POS</span>
                                        </li>
                                        <li>
                                            <span>Stationery</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div class="col-md-4 col-sm-4 col-xs-4 industry-filter" style="display:none;">
                                <span class="cate-filter-title hidden-xs">Type/Industry:</span>
                                <div class="cate-filter-content">
                                    <span class="current-filter hidden-xs">Select a Style<i class="fa fa-angle-down"></i></span>
                                    <span class="current-filter visible-xs">Industry: <i class="fa fa-angle-down"></i></span>
                                    <ul class="product-type-filter">
                                        <li>
                                            <span>Animals</span>
                                        </li>
                                        <li>
                                            <span>Art</span>
                                        </li>
                                        <li>
                                            <span>Automotive</span>
                                        </li>
                                        <li>
                                            <span>Beauty</span>
                                        </li>
                                        <li>
                                            <span>Beverage</span>
                                        </li>
                                        <li>
                                            <span>Child Care</span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div class="col-12 toolbar-actions">
                                <a href="javascript:void(0)" class="btn-back-page" @click="goBack">
                                    <i class="fa fa-long-arrow-left"></i> Back
                                </a>
                                <div class="view-mode">
                                    <a class="view-grid" :class="{ 'active': view == 'Grid' }" @click="view = 'Grid'">
                                        <i class="fa fa-th"></i>
                                    </a>
                                    <a class="view-list" :class="{ 'active': view == 'List' }" @click="view = 'List'">
                                        <i class="fa fa-th-list"></i>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <app-loader v-if="loading" text="Loading products" />
                        <div v-else>
                            <div class="row products-grid category-product" v-if="view == 'Grid' && productsCategory.length > 0">
                                <ul>
                                    <li class="pro-item col-md-4 col-sm-6 col-xs-12" v-for="pro in productsCategory" :key="pro._id">
                                        <a :href="'/custom-product/' + pro._id" :title="pro.productName" class="product-card">
                                            <div class="product-card-img">
                                                <img :src="$store.state.URL + '/uploads/product/' + pro.image" :alt="pro.productName">
                                            </div>
                                            <div class="product-card-body">
                                                <h3 class="product-card-name">{{ pro.productName }}</h3>
                                                <div class="product-card-desc" v-html="pro.productMktDesc"></div>
                                                <span class="product-card-link">View Product <i class="fa fa-long-arrow-right"></i></span>
                                            </div>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                            
                            <div v-if="productsCategory.length == 0" style="text-align: -webkit-center;">
                                <div style="border: 1px solid #c4a86a; padding: 15px; width: 70%; font-size: x-large;">
                                    <p><strong>ACTION REQUIRED :</strong> No products found in the <strong> '{{ formatCategoryName($route.params.category) }}' </strong> category. Please check back later or explore our other categories!</p> <br>
                                </div>
                            </div>
                            <div class="products-list category-product" v-if="view == 'List' && productsCategory.length > 0">
                                <ul>
                                    <li class="pro-item row" v-for="pro in productsCategory" :key="pro._id">
                                        <a :href="'/custom-product/' + pro._id" :title="pro.productName" class="list-card">
                                            <div class="product-image-action col-sm-4 col-xs-12">
                                                <div class="list-card-img">
                                                    <img :src="$store.state.URL + '/uploads/product/' + pro.image" :alt="pro.productName">
                                                </div>
                                            </div>
                                            <div class="product-info col-sm-8 col-xs-12">
                                                <h3 class="product-name">{{ pro.productName }}</h3>
                                                <div class="list-card-desc" v-html="pro.productMktDesc"></div>
                                                <span class="list-card-cta">View Product <i class="fa fa-long-arrow-right"></i></span>
                                            </div>
                                        </a>
                                    </li>

                                </ul>
                            </div>
                        </div>
                    </section><!-- Category product grid : End -->
                </div>
            </div>
        </section>

    </main><!-- Main Category: End -->
    <!--Footer : Begin-->
    <div style="position:relative;">
        <footer-section></footer-section>
    </div>
</div>
</template>

<script>
import NavBarHome from "@/components/NavBarHome.vue"
import FooterSection from "@/components/FooterSection.vue"
import AppLoader from "@/components/AppLoader.vue"
import {
    mapState
} from 'vuex'
import Swal from 'sweetalert2'
export default {
    computed: {
        ...mapState(['categories', 'subCategories', 'productBannerData']),
        groupedSubCategories() {
            if (!this.subCategories) return {};
            return this.subCategories.reduce((acc, sub) => {
                const parentId = sub.category._id;
                if (!acc[parentId]) {
                    acc[parentId] = [];
                }
                acc[parentId].push(sub);
                return acc;
            }, {});
        },
        vw() {
            const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)
            console.log(vw)
            return vw
        }
    },
    components: {
        NavBarHome,
        FooterSection,
        AppLoader
    },
    methods: {
        formatCategoryName(name) {
            return name.replace(/-/g, " ").replace(/\b\w/g, (char) => char.toUpperCase());
        },
        goTo(slug) {
            location.replace(slug)
        },
        goBack() {
            if (window.history.length > 1) {
                this.$router.go(-1);
            } else {
                this.$router.push('/');
            }
        },
        toggleDisplay(id) {
            // Check if there are subcategories for this 'id' (category)
            if (!this.groupedSubCategories[id] || this.groupedSubCategories[id].length === 0) {
                Swal.fire({
                    icon: 'info',
                    title: 'No Subcategories',
                    text: 'There are no subcategories for this item.',
                    customClass: {
                        title: 'swal-title-custom',
                        htmlContainer: 'swal-text-custom',
                        confirmButton: 'swal-confirm-button-custom',
                    }
                });
                return; // Stop execution if no subcategories
            }

            // Accordion behaviour: only one category stays expanded at a time —
            // opening a category collapses the previously opened one
            const isOpen = !!this.openCategories[id];
            this.openCategories = isOpen ? {} : { [id]: true };
        },
        async loadProducts(slug, catName, mainCatSlug) {
            // console.log("loading products", slug)
            this.catName = catName;
            this.productsCategory = await this.$store.dispatch("getsubProductsByCategory", {
                category: slug
            });
            this.$router.push({
                name: "Category",
                params: {
                    category: slug
                }
            })
        },
        async loadCategoryOrSubcategoryProducts() {
            this.loading = true;
            try {
                // Check if slug matches a subcategory
                const subcat = this.subCategories && this.subCategories.find(s => s.slug === this.$route.params.category);
                if (subcat) {
                    this.productsCategory = await this.$store.dispatch("getsubProductsByCategory", {
                        category: subcat.slug
                    });
                    // Find parent category slug for the subcategory
                    const parentCat = this.categories && this.categories.find(c => c._id === subcat.category._id);
                    const parentSlug = parentCat ? parentCat.slug : subcat.category.slug;
                    this.getCatBannerByCategory = await this.$store.dispatch("getCatBannerByCategory", {
                        category: parentSlug
                    });
                } else {
                    this.productsCategory = await this.$store.dispatch("getProductsByCategory", {
                        category: this.$route.params.category
                    });
                    this.getCatBannerByCategory = await this.$store.dispatch("getCatBannerByCategory", {
                        category: this.$route.params.category
                    });
                }
            } finally {
                this.loading = false;
            }
        },
    },
    data() {
        return {
            productsCategory: [],
            getCatBannerByCategory: null,
            view: "Grid",
            catName: '',
            openCategories: {},
            loading: false
        }
    },
    async mounted() {
        await this.$store.dispatch("getCategories")
        await this.$store.dispatch("getProductBannerData")
        await this.loadCategoryOrSubcategoryProducts();
    },
    watch: {
        '$route.params.category': {
            immediate: true,
            handler() {
                this.loadCategoryOrSubcategoryProducts();
            }
        }
    },
}
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Roboto+Condensed:ital,wght@0,100..900;1,100..900&display=swap");

* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

.card-position {
    position: relative;
}

.product-card-wrapper {
    max-width: 208px;
    width: 100%;
    /* border: 1px solid #c32025; */
    position: absolute;
    top: 35%;
    right: 25px;
}

.horizontal-card {
    max-width: 370px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
    gap: 25px;
}

.product-card-wrapper .card-img img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.card-text {
    width: 100%;
    text-align: left;
    padding: 10px 15px 0 15px;
}

.card-text p {
    font-size: 17px;
    font-weight: 400;
    font-family: "Roboto Condensed", sans-serif;
    color: #242656;
    margin-bottom: 10px;
}

.card-text h2 {
    font-size: 24px;
    text-transform: uppercase;
    margin-bottom: 10px;
    color: #444;
    font-weight: 700;
    font-family: "Roboto Condensed", sans-serif;
}

.card-text p a {
    color: #c32025;
}

.card-btn {
    border: none;
    background-color: transparent;
    font-size: 16px;
    font-weight: 400;
    font-family: "Roboto Condensed", sans-serif;
    color: crimson;
    position: relative;
}

.btn-arrow::after {
    position: absolute;
    content: '';
    /* background-image: url(arrow.svg); */
    background-repeat: no-repeat;
    background-size: cover;
    width: 20px;
    height: 20px;
    vertical-align: middle;
    right: -25px;

}

.container {
    max-width: 1170px;
    width: 100%;
    margin: auto !important;
}

.sidebar-title {
    padding-left: 12px;
}

.category-w.parten-bg {
    margin-top: 20px;
}

.c-navbar__sticky .c-navbar__item.second-header a::before {
    opacity: 0;
}

/* product banner */
.postCardWrap {
    display: flex;
    padding: 17px 18px 17px 18px;
    position: relative;
    justify-content: space-between;
    gap: 15px;
    height: 100%;
}

.postCardWrap.position-right {
    flex-direction: row-reverse;
}

.postCardWrap .postCont {
    max-width: 60%;
    width: 100%;
}

.postCardWrap.position-right .postCont {
    max-width: 60%;
    width: 100%;
    margin-left: 17px;
}

.postCardWrap.position-right .postImg {
    max-width: 40%;
    width: 100%;
}

.postCardWrap.position-right .postImg img {
    left: 0;
}

.postCardWrap .postImg {
    max-width: 40%;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.postCardWrap .postImg img {
    width: 100%;
    aspect-ratio: 1/0.6;
    object-fit: cover;
    height: unset;
    position: unset;
}
@media(max-width: 1350px){
    .product-info {
        margin-top: 10px;
    }
}
@media only screen and (max-width: 760px){
    .container{
        padding: 0 15px;
    }
    .postCardWrap {
        flex-direction: column;
    }
    .postCardWrap .postCont {
        max-width: 100%;
        width: 100%;
        margin-bottom: 15px;
    }
    .postCardWrap .postImg {
        max-width: 100%;
        width: 100%;
    }
    .postCardWrap .postImg img {
        height: unset;
        aspect-ratio: unset;
    }
}


/* 4 Sept 20205 */

@media(min-width:992px){
    #cate_list li a.categoryFlexWrap {
    width: 100%;
    display: flex ;
    align-items: center;
    justify-content: space-between;
}

}
.category-w .category {
    margin-bottom: 20px;
}
#cate_list li a{
    line-height: 1.5;
}

@media(max-width:768px){
    aside.hidden-xs{
        display: block!important;
    }
}


/* 8 Sept 20205 */
.container {
    max-width: 1240px;
    padding: 0px 70px;
}
.sidebar-title{
    display: flex;
    align-items: center;
}
.pro-item img{
    object-fit: contain;
    height: 100%;
}
.iconWrapRow{
    display: flex;
    align-items: center;
    justify-content: flex-end;
}
#cate_list li a {
    line-height: 1.5;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
}
.category-image a::before{
    content:unset
 }
 .category-image a::after{
    content:unset
 }
 .product-image-action::before{
    content:unset
 }
 .product-image-action {
  height: auto;
  padding-bottom: 14px !important;
}
.category-product ul{
    max-width: 100%;
}

@media(max-width:768px){
    .container{
        padding:0px 40px;
    }
}

.products-grid.category-product ul{
    padding-left: 15px;
}

/* ── Product cards (Grid view) ─────────────────────── */
.products-grid.category-product ul {
    display: flex;
    flex-wrap: wrap;
    row-gap: 30px;
}

.products-grid.category-product li.pro-item {
    display: flex;
}

.product-card {
    flex: 1;
    display: flex;
    flex-direction: column;
    background: #fff;
    border: 1px solid #ececec;
    border-radius: 12px;
    overflow: hidden;
    text-decoration: none !important;
    box-shadow: 0 1px 4px rgba(36, 38, 86, .06);
    transition: transform .2s ease, box-shadow .2s ease, border-color .2s ease;
}

.product-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 12px 28px rgba(36, 38, 86, .14);
    border-color: #c4a86a;
}

.product-card-img {
    background: #f7f7f9;
    aspect-ratio: 4 / 3;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 14px;
    border-bottom: 1px solid #f0f0f0;
}

.product-card-img img {
    max-width: 100%;
    max-height: 100%;
    width: auto;
    height: auto;
    object-fit: contain;
    transition: transform .25s ease;
}

.product-card:hover .product-card-img img {
    transform: scale(1.05);
}

.product-card-body {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 16px 18px 18px;
    text-align: left;
}

.product-card-name {
    margin: 0;
    font-size: 17px;
    line-height: 1.35;
    font-weight: 700;
    font-family: "Roboto Condensed", sans-serif;
    color: rgb(128, 128, 128);
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
}

.product-card:hover .product-card-name {
    color: #c32025;
}

.product-card-desc {
    margin: 0;
    font-size: 13.5px;
    line-height: 1.55;
    color: #6b7280;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
}

.product-card-link {
    margin-top: auto;
    padding-top: 10px;
    display: inline-flex;
    align-items: center;
    gap: 7px;
    font-size: 13.5px;
    font-weight: 600;
    letter-spacing: .02em;
    text-transform: uppercase;
    color: #c32025;
}

.product-card-link i {
    transition: transform .2s ease;
}

.product-card:hover .product-card-link i {
    transform: translateX(5px);
}

@media (max-width:1024px){
    .products-grid.category-product ul{
        display: flex;
        flex-wrap: wrap;
        gap:25px;
        padding-left: 20px;
    }
    .products-grid.category-product ul li.pro-item {
        max-width: calc(100% / 2 - 20px);
        width: 100%;
    }
    aside{
        padding-right:15px;
    }
    #cate_list li ul li {
    margin-bottom: 10px;
}
}

@media(max-width:480px){
    .products-grid.category-product ul li.pro-item {
        max-width: 100%;
        width: 100%;
    }
}

/* ── Product cards (List view) ───────────────────────── */
.products-list.category-product ul {
    display: flex;
    flex-direction: column;
    gap: 20px;
}
.products-list.category-product li.pro-item {
    margin: 0;
}
.list-card {
    display: flex;
    align-items: stretch;
    width: 100%;
    background: #fff;
    border: 1px solid #ececec;
    border-radius: 12px;
    overflow: hidden;
    text-decoration: none !important;
    box-shadow: 0 1px 4px rgba(36, 38, 86, .06);
    transition: transform .2s ease, box-shadow .2s ease, border-color .2s ease;
}
.list-card:hover {
    transform: translateY(-3px);
    box-shadow: 0 12px 28px rgba(36, 38, 86, .14);
    border-color: #c4a86a;
}
.list-card .product-image-action {
    padding: 0;
    min-height: 0;
    flex: 0 0 240px;
    max-width: 240px;
}
.list-card-img {
    height: 100%;
    min-height: 160px;
    background: #f7f7f9;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 14px;
    border-right: 1px solid #f0f0f0;
}
.list-card-img img {
    max-width: 100%;
    max-height: 160px;
    width: auto;
    height: auto;
    object-fit: contain;
    transition: transform .25s ease;
}
.list-card:hover .list-card-img img {
    transform: scale(1.05);
}
.list-card .product-info {
    display: flex;
    flex-direction: column;
    gap: 8px;
    flex: 1;
    min-width: 0;
    padding: 18px 22px;
    text-align: left;
}
.list-card .product-name {
    margin: 0;
    font-size: 18px;
    line-height: 1.35;
    font-weight: 700;
    font-family: "Roboto Condensed", sans-serif;
    color: rgb(128, 128, 128);
}
.list-card:hover .product-name {
    color: #c32025;
}
.list-card-desc {
    margin: 0;
    font-size: 13.5px;
    line-height: 1.6;
    color: #6b7280;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
}
.list-card-cta {
    margin-top: auto;
    padding-top: 6px;
    display: inline-flex;
    align-items: center;
    gap: 7px;
    font-size: 13.5px;
    font-weight: 600;
    letter-spacing: .02em;
    text-transform: uppercase;
    color: #c32025;
}
.list-card-cta i {
    transition: transform .2s ease;
}
.list-card:hover .list-card-cta i {
    transform: translateX(5px);
}
@media(max-width:767px){
    .list-card {
        flex-direction: column;
    }
    .list-card .product-image-action {
        flex: 0 0 auto;
        max-width: 100%;
        width: 100%;
    }
    .list-card-img {
        border-right: none;
        border-bottom: 1px solid #f0f0f0;
        min-height: 140px;
    }
}

/* ── Back navigation ─────────────────────────────────── */
.toolbar-actions {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
}
.btn-back-page {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    height: 40px;
    font-size: 13px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: .02em;
    color: #c32025;
    text-decoration: none !important;
    padding: 0 16px;
    border: 1px solid #c32025;
    border-radius: 4px;
    transition: all .2s ease;
}
.btn-back-page:hover {
    background: #c32025;
    border-color: #c32025;
    color: #fff;
}
</style>
<style>
/* Global styles for SweetAlert2 customization */
.swal-title-custom {
  font-size: 2em !important;
}

.swal-text-custom {
  font-size: 1.5em !important;
}

.swal-confirm-button-custom {
  font-size: 1.25em !important;
  background-color: #FD5B4E !important
}
ul.cate_list li.parent a i.fa-minus{
    display: block;
}
</style>
